var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect } from "react";
import querystring from "querystring";
import { connect } from '../../store/connect';
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { setAppState } from "../../store/actions";
import { getInitialData, getCancelBookingData, postCancelBookingForm, getCancelBookingEntities } from "../../store/actions/response.actions";
import { APP_STATE } from "../../store/store";
import { Loader } from "../Loader/Loader";
import merge from "lodash/merge";
import pick from "lodash/pick";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { ReactiveForm } from "../Form";
import { componentTypes, componentMapper, validatorMapper } from "../Form/form-constants";
import { getBookManager } from "../../models/BookModel";
import { TwoSidedForm } from "../Form/TwoSidedForm/TwoSidedForm";
import { CONSENT_PAGE } from "../../classConstants";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
var certificatePageFactory = function () {
    var CertificatePageComponent = function (props) {
        var t = useTranslation().t;
        var search = useLocation().search;
        var bookingId = pick(querystring.parse(search.substr(1)), "bookingId").bookingId;
        var getCancelBookingEntities = props.getCancelBookingEntities, postCancelBookingForm = props.postCancelBookingForm, setAppState = props.setAppState, formFields = props.formFields;
        var formValuesRef = React.useRef(props.mergedForm || {});
        useEffect(function () {
            setAppState(APP_STATE.CANCEL_BOOKING);
            getCancelBookingEntities({ bookingId: bookingId });
        }, [bookingId]);
        var onSubmitCancelForm = function () {
            return postCancelBookingForm(__assign(__assign({}, props.mergedForm), { bookingId: bookingId }));
        };
        if (props.hasErrored)
            return null;
        if (props.isLoading)
            return React.createElement(Loader, null);
        if (formFields.length === 0)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement(TwoSidedForm, { className: CONSENT_PAGE, leftSideOnly: true },
                React.createElement(ReactiveForm, { name: props.name, onSubmit: onSubmitCancelForm, componentMapper: componentMapper, validatorMapper: validatorMapper, initialValues: formValuesRef.current, schema: {
                        fields: __spreadArray(__spreadArray([], formFields), [
                            {
                                component: componentTypes.FORM_BUTTONS,
                                submitLabel: t("cancel_booking.submit"),
                                backLabel: t("cancel_booking.back"),
                                hideBackButton: false,
                                name: "form-buttons"
                            }
                        ])
                    } }))));
    };
    var mapStateToProps = function (state) {
        var _a;
        var initialData = getInitialData(state.responseReducer) || null;
        var cancelBookingData = ((_a = getCancelBookingData(state.responseReducer)) === null || _a === void 0 ? void 0 : _a.response) || null;
        var forms = state.formReducer.forms;
        var name = "cancel-booking-form";
        return {
            name: name,
            form: forms[name],
            initialData: initialData,
            cancelBookingData: cancelBookingData,
            loaderState: state.loaderReducer
        };
    };
    var mergeProps = function (stateProps, dispatchProps, ownProps) {
        var _a;
        var initialData = stateProps.initialData, cancelBookingData = stateProps.cancelBookingData, form = stateProps.form, loaderState = stateProps.loaderState, restStateProps = __rest(stateProps, ["initialData", "cancelBookingData", "form", "loaderState"]);
        var loadingState = new LoaderState(loaderState, { keys: [API_METHODS_ENUM.GET_CANCEL_BOOKING_ENTITIES] });
        var info = !initialData ? "" : (((_a = getResponseManager(initialData).options()) === null || _a === void 0 ? void 0 : _a.accept_consents) || "");
        var mergedProps = __assign(__assign(__assign(__assign({}, restStateProps), dispatchProps), ownProps), { name: stateProps.name, info: info, formFields: [], hasErrored: loadingState.hasErrored(), isLoading: !cancelBookingData || (loadingState.isLoading() && !loadingState.hasLoaded()), mergedForm: form || {
                form_data: {
                    form_field: {
                        personal_data: []
                    },
                    form_group: {},
                    consent_agreement: {}
                }
            } });
        if (cancelBookingData) {
            var entities = getResponseManager(cancelBookingData).entities();
            if (!entities)
                return mergedProps;
            mergedProps.mergedForm = merge({}, form);
            mergedProps.formFields = getBookManager(entities).getCancelBookingForm({ formName: stateProps.name }) || [];
        }
        return mergedProps;
    };
    return connect(mapStateToProps, { setAppState: setAppState, getCancelBookingEntities: getCancelBookingEntities, postCancelBookingForm: postCancelBookingForm }, mergeProps)(CertificatePageComponent);
};
export var CancelBookingPage = certificatePageFactory();
